import React, { useEffect, useState } from "react";
import { api_url, titleDescription } from "../../config/Config";
import "react-responsive-modal/styles.css";
import _fetch from "../../config/api";
import toasted from "../../config/toast";
import { useTranslation } from "react-i18next";
import { ColorRing } from "react-loader-spinner";
import CloseIcon from "@mui/icons-material/Close";

const TradePayout = (props: any) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        document.title = `${props.pageTitle} | ${titleDescription}`;
    });

    const [amount, setAmount] = useState();
    const [btnDisable, setbtnDisable] = useState(false);
    const [balance, setBalance] = useState(0);
    //   const [trxpassword, settrxpassword] = useState(0);
    const [checkWithdrawStatus, setCheckWithdrawStatus] = useState(false);
    const [checkOwnWithdraw, setCheckOwnWithdraw] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showtrxInput, setShowTrxInput] = useState(false);
    const [trxPassword, setTRXPassword] = useState('');
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        getBalance();
    }, []);


    const handleConfirm = () => {
        // Your backend call here
        console.log("Withdraw confirmed");
        setShowPopup(false);
        // setShowTrxInput(false);
        // setIsOpen(false);
        // tradeWithdraw();
    };
    const getBalance = async () => {
        setLoading(true);
        const data = await _fetch(
            `${api_url}withdraw/check-trade-balance`,
            "GET",
            {},
            {}
        );
        if (data?.status === "success") {
            setLoading(false);
            setCheckWithdrawStatus(data?.withdrawStatus);
            setCheckOwnWithdraw(data?.checkSelfWithdraw?.withdraw_status);
            setBalance(data?.checkSelfWithdraw?.income_info?.trade_fund);
        }
    };

    const tradeWithdraw = async () => {
        setbtnDisable(true);
        setLoading(true);
        let data = {
            'trxpassword': trxPassword
        }
        let res = await _fetch(`${api_url}withdraw/trade-withdraw`, "POST", data);

        if (res?.status === "success") {
            toasted.success(res?.message);
            getBalance();
            setbtnDisable(false);
            setLoading(false);
        } else {
            toasted.error(res?.message);
            setbtnDisable(false);
            setLoading(false);
        }
    };

    return (
        <>
            <main>
                <div className="buy_section loader_main">
                    {loading && (
                        <div className="spinner_bg">
                            <div className="color_ring">
                                {" "}
                                <ColorRing
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="blocks-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="blocks-wrapper"
                                    colors={[
                                        "#2b3892",
                                        "#2b3892",
                                        "#2b3892",
                                        "#2b3892",
                                        "#2b3892",
                                    ]}
                                />
                            </div>
                        </div>
                    )}
                    <div className="coustom_container">
                        <div className="buy_top_sec">
                            <h4>{t("CAPITAL WITHDRAW")}</h4>
                            {/* <div className="inner_data">
                                <p className="">{t("Balance")} : ${Number(balance)?.toFixed(2)}</p>
                            </div> */}
                        </div>
                        {checkOwnWithdraw == true ? (
                            <div className="row cards_sec">
                                <div className="col-lg-4 ">
                                    {/* <div className="card christmas_card mb-4">
                                        <div className="card-body">
                                            <div className="card_bottom_Sec"> 
                                                <div className="buy-section">
                                                    <p className="select_amount">
                                                        <input type="number" placeholder='Enter Amount' onChange={(e: any) => setAmount(e.target.value)} value={amount} />
                                                    </p>

                                                </div>
                                            </div>

                                        </div>

                                    </div> */}
                                    {/* <button className="button_style w-100 mt-3" onClick={() => tradeWithdraw()} disabled={btnDisable}>
                                        {`${t("Withdraw")}`}
                                    </button> */}
                                    <button
                                        className="button_style w-100 mt-3"
                                        onClick={() => setIsOpen(true)}
                                    >
                                        {" "}
                                        Check Balance{" "}
                                    </button>
                                </div>
                                <div className="col-lg-4 ">
                                    {isOpen && (
                                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 box-dash">
                                            <div className="bg-gray-900 text-white p-6 rounded-lg shadow-lg w-96">
                                                <h2 className="avl-balance">Available Balance</h2>
                                                <p className="remaining-balance">
                                                    ${balance ? balance : 0}
                                                </p>
                                                { }

                                                {!showtrxInput && (
                                                    <button
                                                        className="withdraw-btn button_style"
                                                        onClick={() => setShowTrxInput(true)}
                                                    >
                                                        {" "}
                                                        Proceed{" "}
                                                    </button>
                                                )}

                                                {showtrxInput && (
                                                    <>
                                                        <div className="mb-4">
                                                            <input id="trxId"
                                                                className="w-full px-3 py-2 rounded text-black" type="text" placeholder='Enter Trx Password' onChange={(e: any) => setTRXPassword(e.target.value)} value={trxPassword} />
                                                        </div>
                                                        <div className="for-flexmemt-btn">


                                                            <button
                                                                className="green-button"
                                                                onClick={() => setShowPopup(true)}

                                                            >
                                                                Withdraw
                                                            </button>

                                                            {showPopup && (
                                                                <div style={{ border: "1px solid #ccc", padding: "16px", background: "#4d6fc1", position: "absolute", zIndex: 10 }}>
                                                                    <p>Are you sure you want to withdraw?</p>
                                                                    <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                                                                        <button onClick={() => tradeWithdraw()} >Confirm</button>
                                                                        <button onClick={() => setShowPopup(false)}>No</button>
                                                                    </div>
                                                                </div>
                                                            )}



                                                        </div>
                                                    </>
                                                )}

                                                <CloseIcon
                                                    className="close-icon"
                                                    onClick={() => setIsOpen(false)}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <h4 className="closed-message">Withdraw is Closed by System</h4>
                        )}
                    </div>
                </div>
            </main>
        </>
    );
};

export default TradePayout;
